// 인앱 브라우저(웹뷰) 감지·탈출 — 구글이 웹뷰에서 OAuth 를 차단하므로
// (disallowed_useragent) 카카오톡으로 공유된 링크는 구글 로그인이 막힌다.
// 카카오는 외부 브라우저로 여는 공식 스킴을 제공해 자동 탈출이 가능하고,
// 스킴이 없는 웹뷰(인스타그램·라인 등)는 안내 문구만 보여준다.
//
// UA 는 인자로도 받는다 — node 환경 테스트와, 혹시 모를 SSR 안전을 위해.

function agent(ua?: string): string {
  if (ua !== undefined) return ua;
  try {
    // 데스크톱 미리보기용 오버라이드 — 실기기 없이 배너·펼침을 확인한다.
    // (?inapp=kakao 는 탈출 스킴까지 시도하므로 데스크톱에선 무시되고 폴백이 보인다)
    const dbg = new URLSearchParams(location.search).get("inapp");
    if (dbg === "kakao") return "KAKAOTALK";
    if (dbg === "other") return "Instagram";
    return navigator.userAgent || "";
  } catch {
    return "";
  }
}

/** 카카오톡 인앱 브라우저 — 공식 탈출 스킴이 있다. */
export function isKakaoInApp(ua?: string): boolean {
  return /KAKAOTALK/i.test(agent(ua));
}

/** 탈출 스킴이 없는 기타 인앱 웹뷰 — 안내만 가능. */
export function isOtherInApp(ua?: string): boolean {
  const s = agent(ua);
  return /Instagram|\bLine\/|NAVER\(inapp|FBAN|FBAV|DaumApps/i.test(s) && !isKakaoInApp(s);
}

export function isInApp(ua?: string): boolean {
  return isKakaoInApp(ua) || isOtherInApp(ua);
}

/** 카카오 인앱 → 기기 기본 브라우저로 현재 주소를 연다 (iOS·Android 공통). */
export function kakaoEscapeUrl(target: string): string {
  return "kakaotalk://web/openExternal?url=" + encodeURIComponent(target);
}

export function escapeKakao(): void {
  try {
    // 스킴 이동은 히스토리를 쌓지 않는다 — 무시되는 환경이면 페이지가 그대로
    // 남아 아래 폴백(안내 배너·아이디 로그인)으로 이어진다.
    location.href = kakaoEscapeUrl(location.href);
  } catch {
    /* noop */
  }
}
